import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65fc79c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to stop managing this child account? ", -1))
const _hoisted_2 = {
  key: 0,
  class: "help-text"
}
const _hoisted_3 = {
  key: 1,
  class: "help-text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to remove this parent? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " The parent will no longer have any special access or control over the child account. This will not affect any parent relationship they may have in the family tree. You and any other parents accounts that have been added will continue to manage the child account. ", -1))

import { computed, ref } from 'vue'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import { useTokenManager } from '@/auth/TokenManager'
import { LoadMode } from '@/util/AsyncData'
import { pluralizeWithCount } from '@/util/LanguageUtil'
import Modal from '@/util/Modal.vue'
import UserItem from './UserItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSupervisorRemoveModal',
  setup(__props, { expose: __expose }) {

const userSupervisorIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const userSupervisorStore = useUserSupervisorStore()
const tokenManager = useTokenManager()

const userSupervisorRef = computed(() => userSupervisorStore.getAsyncUserSupervisor(userSupervisorIdRef.value, LoadMode.EnsureLoaded)?.data)
const isSelfRef = computed(() => userSupervisorRef.value?.supervisorId == tokenManager.current.userId)
const allUserSupervisorsRef = computed(() => userSupervisorStore.getForSupervisedUser(userSupervisorRef.value?.forUserId))
const otherSupervisorsRef = computed(() => allUserSupervisorsRef.value.filter(sup => sup.id != userSupervisorIdRef.value))

__expose({
  open,
})

function open(userSupervisorId: string) {
  userSupervisorIdRef.value = userSupervisorId
  modalRef.value?.open()
}

async function removeSupervisor() {
  if (userSupervisorIdRef.value) {
    await userSupervisorStore.deleteAsync(userSupervisorIdRef.value)
    modalRef.value?.close()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-style": "danger",
    onOk: removeSupervisor
  }, {
    title: _withCtx(() => [
      (isSelfRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Stop managing child")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Remove parent account")
          ], 64))
    ]),
    okText: _withCtx(() => [
      (isSelfRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Stop managing")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Remove parent")
          ], 64))
    ]),
    default: _withCtx(() => [
      (isSelfRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _createVNode(UserItem, {
              "user-id": userSupervisorRef.value?.forUserId,
              "select-mode": "",
              class: "supervised"
            }, null, 8, ["user-id"]),
            (otherSupervisorsRef.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " The account will still be supervised by " + _toDisplayString(_unref(pluralizeWithCount)(otherSupervisorsRef.value.length, { singular: "other parent", plural: "other parents" })) + ". ", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_3, " You are the only parent managing this account. If you stop managing it, the child will regain full control, and you will not be able to manage it again without their consent. "))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createVNode(UserItem, {
              "user-id": userSupervisorRef.value?.supervisorId
            }, null, 8, ["user-id"]),
            _hoisted_5
          ], 64))
    ]),
    _: 1
  }, 512))
}
}

})